var map = {
	"./en/errors.json": 89158,
	"./es/errors.json": 94772,
	"./fr/errors.json": 71966,
	"./ja/errors.json": 64076,
	"./kr/errors.json": 37514,
	"./th/errors.json": 21188,
	"./tr/errors.json": 92240,
	"./vi/errors.json": 73359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97329;